class FocusTrap {
  constructor(container, trigger) {
    this.container = container;
    this.trigger = trigger;
    this.onKeydown = this.onKeydown.bind(this);
  }
  activate() {
    this.previous = document.activeElement;
    document.addEventListener('keydown', this.onKeydown);
    requestAnimationFrame(() => this.focusables()[0]?.focus());
  }
  deactivate() {
    document.removeEventListener('keydown', this.onKeydown);
    (this.trigger || this.previous)?.focus();
  }
  focusables() {
    return [...this.container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((item) => item.offsetParent !== null);
  }
  onKeydown(event) {
    if (event.key !== 'Tab') return;
    const items = this.focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}

const liveRegion = () => document.getElementById('LiveRegion');
const announce = (message) => {
  const region = liveRegion();
  if (!region) return;
  region.textContent = '';
  window.setTimeout(() => { region.textContent = message; }, 50);
};

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-open]');
  const menuClose = event.target.closest('[data-menu-close]');
  const filterButton = event.target.closest('[data-filter-open]');
  const filterClose = event.target.closest('[data-filter-close]');
  if (menuButton) window.themeMenu?.open(menuButton);
  if (menuClose) window.themeMenu?.close();
  if (filterButton) document.querySelector('[data-facets]')?.classList.add('is-open');
  if (filterClose) document.querySelector('[data-facets]')?.classList.remove('is-open');
});

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  if (menu) {
    let trap;
    window.themeMenu = {
      open(trigger) { menu.setAttribute('open', ''); document.body.classList.add('menu-open'); trap = new FocusTrap(menu, trigger); trap.activate(); },
      close() { menu.removeAttribute('open'); document.body.classList.remove('menu-open'); trap?.deactivate(); }
    };
  }

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    quantity.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      const input = quantity.querySelector('input');
      if (!button || !input) return;
      const delta = button.dataset.quantityAction === 'increase' ? 1 : -1;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-media-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = document.querySelector('[data-product-main-image]');
      if (!image) return;
      image.src = button.dataset.mediaSrc;
      image.srcset = '';
      image.alt = button.dataset.mediaAlt || '';
      document.querySelectorAll('[data-media-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
    });
  });
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-reveal]').forEach((item) => item.classList.add('is-visible'));
});

window.themeAnnounce = announce;

